import * as React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import Appear from '../../components/Appear/Appear';
import FormField from '../../components/FormField/FormField';
import ReactTags from 'react-tag-autocomplete';
import './MakeupBrands.styles.scss';
import withContainer from '../../containers/WithContainer';
import Button from '../../components/Button/Button';
import { ContainerNew } from '../../containers/AppContainer';
import { withRouter } from 'react-router-dom';

interface MakeupBrandsState {
  isAddButtonDisabled: boolean;
  brandValue: string;
}
class MakeupBrands extends React.Component<any, MakeupBrandsState> {
  public autocomplete;
  app: ContainerNew = this.props.appContainer;

  constructor(props) {
    super(props);
    this.state = {
      isAddButtonDisabled: true,
      brandValue: '',
    };
  }

  handleInputChange = (input: string) => {
    if (input) {
      const hasComma = input[input.length - 1] === ',';
      if (hasComma) {
        input = input.slice(0, -1);
      }
      this.setState(
        {
          brandValue: input,
          isAddButtonDisabled:
            !input ||
            this.app.state.step10.availableBrands.some(
              brand => brand.name.search(input) !== -1
            ),
        },
        () => {
          if (hasComma) {
            this.handleAddClick();
          }
        }
      );
    } else {
      this.setState({
        brandValue: '',
        isAddButtonDisabled: true,
      });
    }
  };

  handleAddClick = () => {
    this.app.handleTagSelect({ name: this.state.brandValue });
    this.setState({ brandValue: '', isAddButtonDisabled: true });
    this.autocomplete.setState({ query: '' });
  };

  onNext = () => {
    this.props.appContainer.updateMakeupBrands(this.getCurrStep());
  };

  getCurrStep = () => {
    let step = parseInt(this.props.match.path.split('-')[1]);
    return step;
  };

  public render() {
    return (
      <WizardCard
        title="What brands do you use?"
        subTitle="Give customers confidence to book you by showing what brands you use."
        delay={2}
        onNext={this.onNext}
        isDisabled={
          !this.app.state.step10 || !this.app.state.step10.selectedBrands.length
        }
      >
        <Appear delay={1.5} className="is-elevated has-margin-top-45">
          <div className="columns is-mobile has-items-end is-marginless">
            <div className="column is-paddingless">
              <FormField label="">
                <ReactTags
                  ref={e => (this.autocomplete = e)}
                  tags={this.app.state.step10.selectedBrands}
                  suggestions={this.app.state.step10.availableBrands}
                  handleDelete={this.app.handleTagRemove}
                  handleAddition={this.app.handleTagSelect}
                  handleInputChange={this.handleInputChange}
                  classNames={{
                    search: 'react-tags__search input',
                    selectedTag: 'tag is-info',
                  }}
                  placeholder="Enter brand"
                  allowBackspace={false}
                  allowNew
                  clearInputOnDelete
                />
              </FormField>
            </div>
            <div className="column is-narrow is-paddingless">
              <Button
                color="primary"
                className="plus-button"
                isDisabled={this.state.isAddButtonDisabled}
                onClick={this.handleAddClick}
                size="small"
              >
                <i className="fas fa-plus" />
              </Button>
            </div>
          </div>
          <div className="column has-padding-top-0 is-paddingless">
            <p className="help is-gray-light">
              Hit the <strong>+</strong> button if the brand you enter doesn't
              show up in the suggestion
            </p>
          </div>
        </Appear>
      </WizardCard>
    );
  }
}

export default withRouter(withContainer(MakeupBrands));
